var _defs, _circle, _circle2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuControlledIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 6,
    floodColor: "#000000",
    floodOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "greenGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#19c748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#118f33"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 240,
    fill: "url(#greenGrad)",
    filter: "url(#glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 234,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 4,
    strokeOpacity: 0.3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 278,
    fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 115,
    fontWeight: 800,
    fill: "#FFFFFF",
    textAnchor: "middle",
    letterSpacing: 2
  }, "EU-C")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuControlledIcon);
export default __webpack_public_path__ + "static/media/EU_controlled_icon.eae79c39b6ac95096ff8d12b8eadfd5b.svg";
export { ForwardRef as ReactComponent };